import React from 'react';
import { motion } from 'framer-motion';
export function ProductReveal() {
  return <section className="py-24 px-4 bg-brand-bg relative" data-id="element-231">
      <div className="max-w-5xl mx-auto text-center" data-id="element-232">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-12" data-id="element-233">
          <p className="text-xl text-brand-textLight mb-4 uppercase tracking-widest font-medium" data-id="element-234">
            Eso es exactamente lo que te enseña:
          </p>
          <h2 className="text-4xl md:text-6xl font-bold text-brand-plum mb-6 flex flex-col items-center gap-4" data-id="element-235">
            <span className="text-5xl" data-id="element-236">🌱</span>
            "Merezco la Vida de Mis Sueños"
          </h2>
          <p className="text-xl md:text-2xl text-brand-rose font-serif max-w-3xl mx-auto" data-id="element-237">
            La guía definitiva de La Abu Aurora para activar tu Subconsciente
            Fértil y transformar tu realidad en prosperidad, amor y abundancia
            genuina
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="relative max-w-4xl mx-auto mb-16" data-id="element-238">
          <div className="absolute inset-0 bg-brand-gold/20 rounded-[3rem] transform -rotate-2 scale-105 blur-2xl" data-id="element-239"></div>
          <img src="https://cdn.magicpatterns.com/uploads/bbrmsZv13ad42xCTdAVVTH/ChatGPT_Image_5_may_2026,_01_35_58_a.m..png" alt="Pack Completo Merezco la Vida de Mis Sueños" className="relative z-10 w-full h-auto rounded-3xl shadow-2xl border border-white/50" data-id="element-240" />
        </motion.div>

        <div className="max-w-3xl mx-auto space-y-6 text-lg md:text-xl text-brand-textLight leading-relaxed" data-id="element-241">
          <p className="font-bold text-brand-plum text-2xl" data-id="element-242">
            Este no es un libro de autoayuda más.
          </p>
          <p data-id="element-243">
            No encontrarás aquí frases vacías ni promesas que suenan bonito pero
            no te llevan a ningún lado.
          </p>
          <p data-id="element-244">
            Esto es el resultado de 35 años de sabiduría vivida — filtrada con
            amor, simplificada para que puedas aplicarla desde hoy, y diseñada
            para producir resultados reales en tu vida real.
          </p>

          <div className="mt-10 p-8 bg-white rounded-2xl border border-brand-rose/20 shadow-sm" data-id="element-245">
            <p className="text-brand-plum font-medium" data-id="element-246">
              A través del{' '}
              <span className="font-bold text-brand-rose" data-id="element-247">
                Método del Jardín Subconsciente™
              </span>{' '}
              aprenderás a limpiar el terreno de tu mente, plantar las semillas
              correctas y crear las condiciones para que la abundancia, el amor
              y el propósito crezcan de forma natural y sostenida.
            </p>
          </div>
        </div>
      </div>
    </section>;
}